module.exports = __webpack_public_path__ + "static/media/cafe_01.34f52771.png";